import './newTransaction.css';
import { Outlet } from 'react-router-dom';

const NewTransaction = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default NewTransaction;
